import { useContext } from 'react'
import { StoreSettingsContext } from 'store/StoreSettingsContext'
import { WithClassName } from 'shared/types/general.types'
import { cn } from 'utils/style'

type StoreBrandProps = WithClassName<{
	size?: 'md' | 'lg'
}>

const logoClassName = {
	md: 'h-12 max-w-[160px]',
	lg: 'h-16 max-w-[184px]'
}

export const StoreBrand = ({ className, size = 'md' }: StoreBrandProps) => {
	const settingsCtx = useContext(StoreSettingsContext)
	const storeName: string = settingsCtx?.storeSettings?.name || 'Smartgo'
	const storeLogo: string | undefined = settingsCtx?.storeSettings?.logo

	if (storeLogo) {
		return (
			<div className={cn('flex min-w-0 items-center', className)}>
				<img
					className={cn('w-auto object-contain', logoClassName[size])}
					src={storeLogo}
					alt={storeName}
				/>
			</div>
		)
	}

	return (
		<div className={cn('flex min-w-0 items-center gap-3', className)}>
			<span className="grid h-9 w-9 shrink-0 place-items-center rounded-md bg-primary font-display text-lg font-bold text-primary-foreground">
				{storeName.charAt(0).toUpperCase()}
			</span>
			<p className="truncate font-display text-[17px] font-bold leading-tight">{storeName}</p>
		</div>
	)
}
